export const HT = {
  NAME: 'ht',
  SCRIPT: `var configObject =  { "appId": "advtp",
    "collectorHost": "dap.hindustantimes.com",
   "pageViewRequired": true,
    "pagePingRequired": false,
    "syncRequired": true,
    "userIdCookie": "_ht_clientid",
       "pltRequired": false, 
    "existingImpressionCapture": false,
    "existingLinkClickCapture": false,
       "webEngageTokenRequired": false
    };
(function(p, l, o, w, i, k, n, g) {
if (!p[i]) { p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []; p.GlobalSnowplowNamespace.push(i); p[i] = function() { (p[i].q = p[i].q || []).push(arguments); }; p[i].q = p[i].q || []; n = l.createElement(o); g = l.getElementsByTagName(o)[0]; n.async = 1; n.src = w; g.parentNode.insertBefore(n, g);  n.onload = function() {     window.dapTracker = new window.dapDataTracker(); dapTracker.init(k); }}}(window, document, 'script', "https://analytics.htmedia.in/analytics-js/tracker.js", 'snowplow', configObject));`,
};
